import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface JobScheduleEditProps {
    scheduleId: number;
    showModal: boolean;
    hideModal(): void;
    saveModal(): void;
}

const JobScheduleEditPopup = (props: JobScheduleEditProps) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [overhireRate, setOverhireRate] = React.useState(0);
    const [reason, setReason] = React.useState("");

    React.useEffect(() => {
        getScheduleOverhireRate();
    }, [props.scheduleId]);

    const getScheduleOverhireRate = async () => {
        const token = await authService.getAccessToken();

        axios.get('api/Job/GetScheduleOverhireRate?ScheduleId=' + props.scheduleId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setOverhireRate(res.data);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleOverHireRateChange = (e: any) => {
        clearError(e);

        setOverhireRate(e.target.value * 1);
    }

    const handleReasonChange = (e: any) => {
        clearError(e);

        setReason(e.target.value);
    }

    const clearError = (e: any) => {
        var error = errors;
        if (e.target.value) {
            delete error[e.target.name];
            setErrors(error);
        }
    }

    const hideModal = () => {
        props.hideModal();
    }

    const validate = () => {
        let error: any = {};
        let formIsValid = true;

        if (overhireRate <= 0) {
            formIsValid = false;
            error["overhireRate"] = "Overhire Rate must be > 0!";
        }

        if (!reason || reason.trim() === "") {
            formIsValid = false;
            error["reason"] = "Reason for updating the overhire rate is required!";
        }

        setErrors(error);

        return formIsValid;
    }

    const saveOverhireRate = () => {
        if (validate()) {
            saveScheduleOverhireRate();
        } else {
            toast.error("Fix errors on screen before saving!");
        }
    }

    const saveScheduleOverhireRate = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var scheduleJob = {
            scheduleId: props.scheduleId,
            overhireRate: overhireRate,
            reason: reason,
            subId: user.sub
        };

        //schedule job
        axios.post('api/Job/UpdateJobScheduleOverhireRate', scheduleJob, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Overhire Rate successfully");
            props.saveModal();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    return (
        <Modal show={props.showModal} onHide={hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Update Overhire Rate</Modal.Title>
                <button type="button" className="close modal__close--colour" onClick={hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div className="errors">NOTE: This will NOT udpate any existing invoices!</div>
                <label className="input-group" htmlFor="overhireRate">
                    <span className="label">Overhire Rate</span>
                    <input className="input textalignright" type="number" id="overhireRate" name="overhireRate" value={overhireRate} onChange={(e) => { handleOverHireRateChange(e); }}></input>
                </label>
                <span className={errors["overhireRate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["overhireRate"]}</span>

                <label className="input-group" htmlFor="reason">
                    <span className="label">Reason for updating</span>
                    <textarea className="input allocate__teamnotes" id="reason" name="reason" value={reason} onChange={(e) => handleReasonChange(e)}></textarea>
                </label>
                <span className={errors["reason"] ? "label errors" : "hidden"}>{errors["reason"]}</span>
            </Modal.Body>
            <Modal.Footer>
                <button className="popup-button--yes" onClick={saveOverhireRate}>Save</button>
            </Modal.Footer>
        </Modal>
    )
}

export default JobScheduleEditPopup;